import { render, staticRenderFns } from "./AppGlobalAlerts.vue?vue&type=template&id=4e599217&"
import script from "./AppGlobalAlerts.vue?vue&type=script&lang=js&"
export * from "./AppGlobalAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports